module.exports = __webpack_public_path__ + "static/img/1031.8e1a467.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1031.jpg
// module id = 213
// module chunks = 0